import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4">
            <div className="max-w-4xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    {/* 404 Number */}
                    <motion.h1
                        className="text-9xl md:text-[12rem] font-bold text-brand-green mb-4"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                    >
                        404
                    </motion.h1>

                    {/* Error Message */}
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-black mb-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
                    >
                        Page Not Found
                    </motion.h2>

                    <motion.p
                        className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
                    >
                        Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or the URL might be incorrect.
                    </motion.p>

                    {/* Action Buttons */}
                    <motion.div
                        className="flex flex-col sm:flex-row gap-4 justify-center items-center"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
                    >
                        <Link
                            to="/"
                            className="inline-block bg-brand-orange text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-brand-orange-hover transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                        >
                            Go to Homepage
                        </Link>
                        <button
                            onClick={() => navigate(-1)}
                            className="inline-block border-2 border-brand-green text-brand-green px-8 py-4 rounded-lg font-semibold text-lg hover:bg-brand-green hover:text-white transition-colors duration-300"
                        >
                            Go Back
                        </button>
                    </motion.div>

                    {/* Quick Links */}
                    <motion.div
                        className="mt-12"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 1, ease: "easeOut" }}
                    >
                        <p className="text-gray-600 mb-4">Or visit one of these popular pages:</p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <Link
                                to="/insulation"
                                className="text-brand-green hover:text-brand-orange transition-colors duration-300 font-medium"
                            >
                                Insulation
                            </Link>
                            <span className="text-gray-400">•</span>
                            <Link
                                to="/garage-door"
                                className="text-brand-green hover:text-brand-orange transition-colors duration-300 font-medium"
                            >
                                Garage Door
                            </Link>
                            <span className="text-gray-400">•</span>
                            <Link
                                to="/healthy-home"
                                className="text-brand-green hover:text-brand-orange transition-colors duration-300 font-medium"
                            >
                                Healthy Home
                            </Link>
                            <span className="text-gray-400">•</span>
                            <Link
                                to="/contact"
                                className="text-brand-green hover:text-brand-orange transition-colors duration-300 font-medium"
                            >
                                Contact
                            </Link>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
}

export default NotFound;

